export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "invoices",
      layout: "dashboard",
    },
    path: "/invoices",
    name: "invoices",
    component: () => import("@/layouts/index/InvoiceIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des factures",
          layout: "dashboard",
        },
        path: "index",
        name: "invoices-index",
        component: () => import("@/views/invoices/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer une facture",
          layout: "dashboard",
        },
        path: ":reference/create",
        name: "invoices-create",
        component: () => import("@/views/invoices/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier une facture",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "invoices-edit",
        component: () => import("@/views/invoices/Edit.vue"),
      },
    ],
  },
];
